import React from 'react'
import DotsBackground from './DotsBackground'
import './AnimatedBorderButton.css'
import { useRouter } from 'next/navigation'
import Cookies from 'js-cookie'
import { trackModalBenefitInHome } from '@/events/signUpEvents'
import posthog from 'posthog-js'

function PromotionalBanner({
  path = '/my-subscriptions'
}) {
    const router = useRouter()

    const handleRedirection = () => {
      if (posthog.isFeatureEnabled('register-logs') ) {
        trackModalBenefitInHome()
    }
      Cookies.remove('new_users_add')
      router.push(path)
    }

  return (
    <div className="relative overflow-hidden bg-[linear-gradient(273deg,_#7939CC_13.61%,_#4531BA_96.07%)] w-full rounded-xl p-6 text-white">
        <div className='mb-10'>
            <p className=' text-xxs'>Accedé a tu beneficio</p>
            <p className='text-lg font-bold'>Guardia Premium</p>
        </div>
        <div className="animated-border-wrapper">
            <button className="animated-border-button" onClick={handleRedirection}>
            Quiero mi beneficio
            </button>
        </div>

      <div className="absolute bottom-0 right-0 flex items-center justify-center">
        <DotsBackground />
      </div>
    </div>
  )
}

export default PromotionalBanner